export const UI_ROUTES = {
  auth: {
    register: 'auth/register',
    login: 'auth/login',
    validate: 'auth/validate',
    reset: 'auth/reset',
    host: {
      validate: 'auth/host/:hostId/validate',
    },
    member: {
      join: 'auth/member/:memberId/join',
    }
  },
  account: {
    dashboard: 'account',
    user: {
      settings: 'account/user/settings'
    },
    activity: {
      dashboard: 'account/activity',
      create: 'account/activity/create',
      home: 'account/activity/:activityId',
      preview: 'account/activity/:activityId/preview',
      edit: 'account/activity/:activityId/edit',
      editAbout: 'account/activity/:activityId/edit/about',
      editPrice: 'account/activity/:activityId/edit/price',
      editLinks: 'account/activity/:activityId/edit/links',
      schedule: {
        edit: 'account/activity/:activityId/schedule/:scheduleId/edit',
      },
    },
    host: {
      dashboard: 'account/host',
      home: 'account/host/:hostId',
      edit: 'account/host/:hostId/edit',
      activities: 'account/host/:hostId/activity'
    }
  },
  admin: {
    dashboard: 'ops',
    user: {
      dashboard: 'ops/user',
      home: 'ops/user/:userId'
    },
    activity: {
      dashboard: 'ops/activity',
      home: 'ops/activity/:activityId',
      preview: 'ops/activity/:activityId/preview',
      edit: 'ops/activity/:activityId/edit',
      editAbout: 'ops/activity/:activityId/edit/about',
      editPrice: 'ops/activity/:activityId/edit/price',
      editLinks: 'ops/activity/:activityId/edit/links',
      schedule: {
        edit: 'ops/activity/:activityId/schedule/:scheduleId/edit',
      }
    },
    activityTag: {
      dashboard: 'ops/activity-tag',
      home: 'ops/activity-tag/:tagId',
      edit: 'ops/activity-tag/:tagId/edit',
    },
    host: {
      dashboard: 'ops/host',
      register: 'ops/host/register',
      home: 'ops/host/:hostId',
      edit: 'ops/host/:hostId/edit',
      profile: 'ops/host/:hostId/profile',
      invitation: {
        dashboard: 'ops/host/invitation',
        home: 'ops/host/invitation/:invitationId',
      }
    },
    place: {
      dashboard: 'ops/place',
      home: 'ops/place/:placeId',
      edit: 'ops/place/:placeId/edit',
    }
  },
  public: {
    dashboard: '',
    activity: {
      search: 'activity/search',
      publish: 'activity/publish',
      home: 'activity/:slug'
    },
    host: {
      home: 'host/:slug'
    },
    place: {
      home: 'place/:slug'
    },
    terms: {
      home: 'terms',
      publish: 'terms/publish',
      privacy: 'terms/privacy'
    },
    faq: 'faq',
    partners: 'partners',
    contact: 'contact',
    about: 'about',
    supportUs: 'support-us'
  }
};
